import { render, staticRenderFns } from "./ManagedTransfersActivity.vue?vue&type=template&id=4e5cf4f2"
import script from "./ManagedTransfersActivity.vue?vue&type=script&lang=ts"
export * from "./ManagedTransfersActivity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports